/* eslint-disable no-console */
import * as Sentry from '@sentry/browser'
import { formatArgs } from './argsUtils'

export class Logger {
  constructor(builder) {
    this.enableSentry = builder.enableSentry
    this.context = builder.context
  }

  _formatMessage(message) {
    return this.context ? `[${this.context}] ${message}` : message
  }

  _handleSentry(message, methodLevel, args = []) {
    if (!this.enableSentry) return

    if (methodLevel === 'error') {
      const error = args.find((arg) => arg instanceof Error)
      Sentry.captureException(error || new Error(message))
      return
    }

    Sentry.captureMessage(
      message,
      methodLevel === 'warn' ? 'warning' : methodLevel
    )
  }

  log(...args) {
    const message = formatArgs(...args)
    const formattedMessage = this._formatMessage(message)
    console.log(formattedMessage)
    this._handleSentry(formattedMessage, 'log')
  }

  info(...args) {
    const message = formatArgs(...args)
    const formattedMessage = this._formatMessage(message)
    console.info(formattedMessage)
    this._handleSentry(formattedMessage, 'info')
  }

  warn(...args) {
    const message = formatArgs(...args)
    const formattedMessage = this._formatMessage(message)
    console.warn(formattedMessage)
    this._handleSentry(formattedMessage, 'warn')
  }

  error(...args) {
    const message = formatArgs(...args)
    const formattedMessage = this._formatMessage(message)
    console.error(formattedMessage)
    this._handleSentry(formattedMessage, 'error', args)
  }

  static get Builder() {
    class Builder {
      constructor() {
        this.enableSentry = false
        this.context = ''
      }

      enableSentryIntegration(enable = true) {
        this.enableSentry = enable
        return this
      }

      setContext(context) {
        this.context = context
        return this
      }

      build() {
        return new Logger(this)
      }
    }

    return Builder
  }
}
